export const DEFAULT_FONTS = [
  { id: 'primary', label: 'Primary (Headings)', value: 'Montserrat, sans-serif', googleFont: 'Montserrat' },
  { id: 'secondary', label: 'Secondary (Body)', value: 'Open Sans, sans-serif', googleFont: 'Open Sans' },
]

export const FONT_OPTIONS = [
  { label: 'System Default', value: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
  { label: 'Montserrat', value: 'Montserrat, sans-serif', googleFont: 'Montserrat' },
  { label: 'Open Sans', value: 'Open Sans, sans-serif', googleFont: 'Open Sans' },
  { label: 'Roboto', value: 'Roboto, sans-serif', googleFont: 'Roboto' },
  { label: 'Lato', value: 'Lato, sans-serif', googleFont: 'Lato' },
  { label: 'Poppins', value: 'Poppins, sans-serif', googleFont: 'Poppins' },
  { label: 'Raleway', value: 'Raleway, sans-serif', googleFont: 'Raleway' },
  { label: 'Playfair Display', value: 'Playfair Display, serif', googleFont: 'Playfair+Display' },
  { label: 'Merriweather', value: 'Merriweather, serif', googleFont: 'Merriweather' },
  { label: 'Inter', value: 'Inter, sans-serif', googleFont: 'Inter' },
  { label: 'Nunito', value: 'Nunito, sans-serif', googleFont: 'Nunito' },
  { label: 'Source Sans Pro', value: 'Source Sans Pro, sans-serif', googleFont: 'Source+Sans+Pro' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
]

export function buildFontCssVars(fonts) {
  return fonts.map(f => `  --eb-font-${f.id}: ${f.value};`).join('\n')
}

export function getGoogleFontUrl(fonts) {
  const googleFonts = fonts.filter(f => f.googleFont).map(f => f.googleFont.replace(/ /g, '+'))
  if (!googleFonts.length) return ''
  return `https://fonts.googleapis.com/css2?${googleFonts.map(f => `family=${f}:wght@300;400;500;600;700;800;900`).join('&')}&display=swap`
}
